<template>
  <div class="mzixunWrap">
    <div class="mzixunLeft white">
      <div class="abstractIitem">
        <div class="itemTile">
          <h3>分数线</h3>
        </div>
        <div class="fenshu" v-if="tianbaoType == 0">
          <div class="txt">
            <h4>{{areaInfo.areaFullName}}—{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}—院校录取分数线</h4>
          </div>
          <div class="fenshuTable">
            <table>
              <tr>
                <th>年份</th>
                <th>地区</th>
                <th>批次</th>
                <th>人数</th>
                <th>最低分</th>
                <th>位次</th>
              </tr>
              <tbody v-for="(item,index) in collegeScore" style="border-bottom: 1px solid #ddd;">
                <tr v-for="(it,i) in item.list">
                  <td>{{it.scoreYear}}</td>
                  <td>{{areaInfo.areaName}}</td>
                  <td>{{item.obj.plan_batch}}
                  <br v-if="item.obj.college_info!=null&&item.obj.college_info!=''">
                  <span style="color: red;" v-if="item.obj.college_info!=null&&item.obj.college_info!=''">{{item.obj.college_info}}</span>
                  </td>
                  <td>{{it.scorePlanNum == 0?'--':it.scorePlanNum}}</td>
                  <td>{{it.scoreMin}}</td>
                  <td>{{it.scoreMinRank}}</td>
                </tr>
              </tbody>

            </table>

          </div>
        </div>
        <div class="fenshu" v-if="tianbaoType == 0">
          <div class="txt">
            <h4>{{areaInfo.areaFullName}}—{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}-专业录取分数线</h4>
          </div>
          <div class="majorfenTable">
            <table style="background-color: #FFFFFF;">
              <tr style="display: flex;">
                <th style="width: 200px;display: flex;justify-content: center;">专业</th>
                <th style="width: 100px;display: flex;justify-content: center;">批次</th>
                <th style="width: 416px;display: flex;justify-content: space-between;">
                  <div style="width: 25%;">年份</div>
                  <div style="width: 25%;">人数</div>
                  <div style="width: 25%;">最低分</div>
                  <div style="width: 25%;">位次</div>
                </th>
              </tr>
              <tr v-for="(item,index) in majorScore" style="display: flex;border-bottom: 1px solid #c0c4cc;">
                <td
                  style="width: 200px;display: flex;flex-direction: column;text-align: left;border-left: 1px solid #c0c4cc;">
                  <div style="color: #FF0000;font-size: 18px;">{{item.obj.major_name}}</div>
                  <el-tooltip effect="dark" placement="right">
                    <div style="font-size: 12px;" v-if="item.obj.major_info!=null&&item.obj.major_info!=''">
                    {{item.obj.major_info.length>15?item.obj.major_info.substring(0,15)+"...":item.obj.major_info}}
                    </div>
                    <div style="height: auto;width: auto; max-width: 200px;color: #ffffff;" slot="content">
                      {{item.obj.major_info}}
                    </div>
                  </el-tooltip>
                </td>
                <td style="width: 100px;display: flex;align-items: center;justify-content: center;">{{item.obj.plan_batch}}</td>
                <td style="width: 416px;display: flex;flex-direction: column;border: 0; padding: 0;">
              <tr v-for="(obj,i) in  getscore(item.list)" style="width: 416px;justify-content: space-between;"
                :style="{borderTop: i!=0?'1px solid #c0c4cc':''}">
                <td style="width: 100px;color: #FF0000;" v-if="obj!=null">{{obj.scoreYear}}</td>
                <td style="width: 100px;" v-if="obj!=null">{{obj.scorePlanNum}}</td>
                <td style="width: 100px;" v-if="obj!=null">{{obj.scoreMin}}</td>
                <td style="width: 116px;" v-if="obj!=null">{{obj.scoreMinRank}}</td>
              </tr>
              </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="fenshu" v-if="tianbaoType != 0">
          <div class="txt">
            <h4>{{areaInfo.areaFullName}}—{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}-专业录取分数线</h4>
          </div>
          <div class="majorfenTable">
            <table style="background-color: #FFFFFF;">
              <tr style="display: flex;">
                <th style="width: 200px;display: flex;justify-content: center;">专业</th>
                <th style="width: 100px;display: flex;justify-content: center;">批次</th>
                <th style="width: 416px;display: flex;justify-content: space-between;">
                  <div style="width: 25%;">年份</div>
                  <div style="width: 25%;">人数</div>
                  <div style="width: 25%;">最低分</div>
                  <div style="width: 25%;">位次</div>
                </th>
              </tr>
              <tr v-for="(item,index) in majorScore" v-if="item.list!=null" style="display: flex;border-bottom: 1px solid #c0c4cc;">
                <td
                  style="width: 200px;display: flex;flex-direction: column;text-align: left;border-left: 1px solid #c0c4cc;">
                  <div style="color: #FF0000;font-size: 18px;">{{item.major_name}}</div>
                  <el-tooltip effect="dark" placement="right">
                    <div style="font-size: 12px;" v-if="item.major_info!=null&&item.major_info!=''">
                    {{item.major_info.length>15?item.major_info.substring(0,15)+"...":item.major_info}}
                    </div>
                    <div style="height: auto;width: auto; max-width: 200px;color: #ffffff;" slot="content">
                      {{item.major_info}}
                    </div>
                  </el-tooltip>

                </td>
                <td style="width: 100px;display: flex;align-items: center;justify-content: center;">{{item.plan_batch}}
                </td>
                <td style="width: 416px;display: flex;flex-direction: column;border: 0; padding: 0;">
              <tr v-for="(obj,i) in  getscore(item.list)" style="width: 416px;justify-content: space-between;"
                :style="{borderTop: i!=0?'1px solid #c0c4cc':''}">
                <td style="width: 100px;color: #FF0000;" v-if="obj!=null">{{obj.scoreYear}}</td>
                <td style="width: 100px;" v-if="obj!=null">
                  {{obj.scorePlanNum == 0||obj.scorePlanNum == null?'--':obj.scorePlanNum}}</td>
                <td style="width: 100px;" v-if="obj!=null">{{obj.scoreMin}}</td>
                <td style="width: 116px;" v-if="obj!=null">{{obj.scoreMinRank}}</td>
              </tr>
              </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="abstractRight white">
      <div class="abstractIitem">
        <div class="itemTile">
          <h3>招生计划分布</h3>
        </div>
        <div class="plr20">
          <tibiao></tibiao>
          <!-- <div class="fenbuBox">
								<div class="fenbu" id="fenbu"></div>
							</div> -->
        </div>
      </div>
      <div class="abstractIitem">
        <div class="itemTile">
          <h3>专业分布</h3>
        </div>
        <div class="plr20">
          <ul class="lingyuList">
            <li>
              <h5>计算机</h5>
              <div class="xian">
                <span style="width: 21%;"></span>
              </div>
              <h6>21%</h6>
            </li>
            <li>
              <h5>语言</h5>
              <div class="xian">
                <span style="width: 17%;"></span>
              </div>
              <h6>17%</h6>
            </li>
            <li>
              <h5>服务</h5>
              <div class="xian">
                <span style="width: 18%;"></span>
              </div>
              <h6>18%</h6>
            </li>
            <li>
              <h5>新能源</h5>
              <div class="xian">
                <span style="width: 17%;"></span>
              </div>
              <h6>17%</h6>
            </li>
            <li>
              <h5>其他</h5>
              <div class="xian">
                <span style="width: 31%;"></span>
              </div>
              <h6>31%</h6>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import tibiao from "../../tubiao/fengshuxian_tb.vue"
  export default {
    name: "",
    components: {
      tibiao,
    },

    data() {
      return {
        collegeScore: [],
        areaInfo: this.$utils.getlocalStorage("areaInfo"),
        scoreInfo: this.$utils.getlocalStorage("scoreInfo"),
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage("SUBJECTTYPEOBJ"),
        dialogVisible: false,
        majorScore: [],
        tianbaoType: this.$utils.getlocalStorage("tianbaoType"),
        collegescoryear: 2022,
        majorscoryear: 2025,
      }
    },
    props: {
      id: {
        type: String,
        default: ''
      }
    },
    created() {
      console.log(0)
      if (this.tianbaoType == 0) {
        this.getData();
        // this.getmajorData();
      } else if (this.tianbaoType == 1) {
        this.getmajorData();
      } else if (this.tianbaoType == 2) {
        this.getmajorData();
      }

    },
    methods: {
      getxinData() {

      },
      getscore(list) {
        let _this = this;
        let listr = []
        let ad = {
          scoreYear: "-",
          scorePlanNum: "-",
          scoreMin: "-",
          scoreMinRank: "-",
        };
        if (list != null) {
          if (list.length < 3) {
            if(list.length == 2){
              if(list[0].scoreYear == this.majorscoryear){
                listr.push(list[0])
                if(list[1].scoreYear == this.majorscoryear-1){
                  listr.push(list[1])
                  listr.push(ad)
                } else {
                  listr.push(ad)
                  listr.push(list[1])
                }
              } else{
                listr.push(ad)
                listr.push(list[0])
                listr.push(list[1])
              }


            } else if (list.length == 1){
              console.log(list[0].scoreYear+"-------"+this.majorscoryear)
              if(list[0].scoreYear == this.majorscoryear){
                listr.push(list[0])
                listr.push(ad)
                listr.push(ad)

              } else if(list[0].scoreYear == this.majorscoryear-1){
                listr.push(ad)
                listr.push(list[0])
                listr.push(ad)
              } else if(list[0].scoreYear == this.majorscoryear-2){
                listr.push(ad)
                listr.push(ad)
                listr.push(list[0])
              }
            }
          }  else{
            listr.push(list[0])
            listr.push(list[1])
            listr.push(list[2])
          }
        } else {
          listr.push(ad)
          listr.push(ad)
          listr.push(ad)
        }
        for(let i= 0;i<listr.length;i++){
          if(listr[i].scoreMin==null||listr[i].scoreMin==''||listr[i].scoreMin+""=='0'){
            listr[i] = ad;
          }
        }
        return listr;

      },

      getData() {

        let _this = this;
        this.$req.queryScorByCollege({
          pageSize: 10,
          pageNum: 1,
          queryObj: {
            collegeId: this.id,
            scoreArea: this.areaInfo.areaId,
            areaId: this.areaInfo.areaId,
            scoretype: this.scoreInfo.scoreSubject,
            scoreSubject: this.scoreInfo.scoreSubject,
            tianbaoType: this.tianbaoType
          }
        }).then(function(response) {
          _this.collegeScore = response.data.collegescore
          _this.majorScore = response.data.majorscore
          _this.collegescoryear = response.data.yxyear
          _this.majorscoryear = response.data.zyyear
        })
      },
      getmajorData() {
        let _this = this;
        this.$req.queryMajorScorByCollegeScore({
          pageSize: 10,
          pageNum: 1,
          queryObj: {
            collegeId: this.id,
            scoreArea: this.areaInfo.areaId,
            scoretype: this.scoreInfo.scoreSubject,
            tianbaoType: this.tianbaoType
          }
        }).then(function(response) {
          _this.majorScore = response.data
          _this.majorscoryear = response.year
        })
      },
    }
  }
</script>

<style scoped>
  .el-dialog__body {
    padding-top: 0;
  }

  .wrap {
    background: #FBFBFB;
  }

  /* 右边固定 */
  .zuotab {
    height: auto;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%);
  }

  .zuotab figure {
    cursor: pointer;
    margin: 8px 0;
    width: 64px;
    height: 62px;
    border: 1px solid #FF0000;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .zuotab figure img {
    width: 20px;
    height: 20px;
  }

  .zuotab figure figcaption {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/xyzy_fengshuxian.vue